import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { UserApiService } from '../../shared/services/api/user-api.service';
import { DIVE_EMBED_MANAGE } from './dive-embed-permissions';

/**
 * Route guard for the CSS Dive-publishing admin surface
 * (`/admin/dive-publishing`, GF-5419).
 *
 * Reads the caller's DB-granted permissions from `GET /user/auth/me` and
 * activates the route only if `dive_embed.manage` is present. Mirrors
 * `columnMappingAdminGuard`.
 */
export const diveEmbedAdminGuard: CanActivateFn = async () => {
  const userApi = inject(UserApiService);
  const router = inject(Router);
  try {
    const me = await firstValueFrom(userApi.getUserData());
    if (me.permissions?.includes(DIVE_EMBED_MANAGE)) {
      return true;
    }
  } catch {
    // Network / auth issues fall through to redirect — the authTokenInterceptor
    // already handles the 401/403 cases at the HTTP layer.
  }
  return router.createUrlTree(['/home']);
};
